import { PluginType } from '../../domain';
export var facebookApiRelativePath = "/facebook";
export var createFacebookApi = function (baseUrl, http) {
    var apiUrl = "" + baseUrl + facebookApiRelativePath;
    return {
        goToConnectFacebookPage: function (pathName) {
            window.location.href = apiUrl + "/auth?redirectUrl=" + window.location.origin + (pathName || window.location.pathname);
        },
        connectFacebookPage: function (dto) {
            return http.post(apiUrl + "/pages", dto);
        },
        getAccountFacebookPages: function (dto) {
            return http.get(apiUrl + "/pages?code=" + dto.code + "&redirectUri=" + window.location.origin + window.location.pathname);
        },
        getConnectedFacebookPages: function (dto) {
            return http.get(apiUrl + "/connections?type=" + PluginType.FACEBOOK_PAGE + "&checkTokenStatus=" + !!(dto === null || dto === void 0 ? void 0 : dto.checkTokenStatus));
        },
        removeConnectedFacebookPage: function (dto) {
            return http.delete(apiUrl + "/connections/" + dto.id);
        },
        updateConnectedFacebookPage: function (dto) {
            return http.put(apiUrl + "/connections/" + dto.id, dto);
        },
        getFacebookTokensStatus: function (dto) {
            var pagesParam = dto.pages ? "pages=" + dto.pages.join(',') : '';
            var onlyInvalidParam = dto.onlyInvalid ? "onlyInvalid=true&" : '';
            var queryParams = (onlyInvalidParam || pagesParam) ? "?" + onlyInvalidParam + pagesParam : '';
            return http.get(apiUrl + "/connections/status" + queryParams);
        },
    };
};
//# sourceMappingURL=index.js.map